import { createRoute } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import {
  isStorageFilter,
  type StorageFilter,
  StorageManager,
} from "@/features/admin/components/storage-manager";
import { PageContainer } from "@fleet/ui";

function AdminStoragePage() {
  return (
    <PageContainer maxWidth="5xl">
      <StorageManager />
    </PageContainer>
  );
}

interface AdminStorageSearch {
  filter?: StorageFilter;
}

export const adminStorageRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/storage",
  // Shareable object filter: default value (`all`) is omitted.
  validateSearch: (search: Record<string, unknown>): AdminStorageSearch => ({
    filter: isStorageFilter(search.filter) && search.filter !== "all" ? search.filter : undefined,
  }),
  component: AdminStoragePage,
});
